require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/object/set-prototype-of.js
// module id = 219
// module chunks = 1 2